import React from 'react';
import { useSelector } from 'react-redux';

const SectionPromo = ({ obscured, ...props }) => {
    console.log('SectionPromo props:', props);
    const signed_in = useSelector(state => state?.reader?.user?.signed_in);
    
    return (
        <div className='w-full my-4 relative flex justify-center items-center py-6 px-2 bg-[#bae6fd] rounded-md'>
            <div className="max-w-2xl flex flex-col justify-center items-center gap-3 ">
                <span className='material-symbols-outlined'>lock</span>
                <h4 className='text-base sm:text-lg md:text-xl whitespace-nowrap'>
                    {props.heading}
                </h4>
                <div dangerouslySetInnerHTML={{ __html: props.content }} className='text-sm sm:text-base text-center' />
                <a
                    className='px-30px py-13px bg-black text-sm sm:text-base text-white font-space-grotesk uppercase'
                    href={props.cta_link}
                    target='_blank'
                    rel='noreferrer'
                >
                    {props.cta_text}
                </a>
                {!signed_in && (
                    <p className='text-sm text-center whitespace-nowrap mb-0'>
                        Already a subscriber?{' '}
                        <a href={`${process.env.REACT_APP_LOGIN_LINK}?redirect=${encodeURIComponent(window.location.href)}`} className='underline'>
                            Login
                        </a>
                    </p>
                )}
            </div>
        </div>
    );
};

export default SectionPromo;
